<template>
    <div class="h-100 dashboard-widget">
        <div style="display: flex;
    justify-content: space-between;">
            <div style="text-align: initial;
                padding-inline-start: 3%;">
                <h6 class="ml-2 mb-0 pt-3 pb-1" style="color: #b5b5b5" >{{$t('Bins Storage')}}</h6>
            </div>
        </div>
        <div class="widget-sub-wrapper">
            <div v-for="item in storageData" :key="item.bin_id" style="text-align: initial;padding:9px">
                <div style="display: flex;flex-direction: row;justify-content: space-between;">
                    <div>{{item.bin_id}}</div>
                    <div v-if="item.percent && item.percent != '-'" style="font-size: 10px;position: relative;top: 4px;inset-inline-start:3px;">{{item.percent}}%</div>
                </div>
                <div v-if="Object.keys(item).includes('percent') && item.percent != '-'" style="margin: 6px 0px">
                    <div :title="'Used space: ' + item.percent + '%'" class="progress" style="height: 10px;">
                        <div class="progress-bar" role="progressbar" :style="{'width': item.percent + '%','background' : item.color}" :aria-valuenow="item.percent" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
                <div class="other-info">
                    <div>{{$t('Total space')}}: <span>{{item.total_space=='-'?'NA':humaniseSize(item.total_space)}}</span></div>
                    <div v-if="item.total_space=='-'" style="margin-inline-start:4px">{{$t('Used space')}}: <span>{{item.used_space=='-'?'NA':humaniseSize(item.used_space)}}</span></div>
                </div>
            </div>
            <div v-if="storageData.length == 0" class="loading">{{$t('Loading')}}...</div>
        </div>
    </div>
</template>

<script>
import { mapActions} from "vuex";
import Constants from "../../components.constants.js"

export default ({
    data(){
        return{
            acceptedStatusCodes: Constants.acceptedStatusCodes,
            rejectedStatusCodes: Constants.rejectedStatusCodes,
            storageData: [],
            openDashboardPluginStore:false,
            progressBarColors:["#34B3F1","#9EB23B","#FBCB0A","#F77E21","#5B4B8A","#73777B","#EB5353"],
            progressBarColorsDummy:["#34B3F1","#9EB23B"],
            showActionsDropdown:false
        }
    },
    methods:{
        humaniseSize(bytes){
            let data = this.humanizeSize(bytes)
            return `${data["value"]} ${data["unit"]}`
        },
        humanizeSize(bytes) {
            if (!bytes || bytes == 0) {
                return { "value": 0, "unit": "KB" };
            }
            if (bytes < 0) {
                return { "value": 0, "unit": "KB" };
            }
            if (bytes < 1024) return { "value": bytes, "unit": "B" };
            else if (bytes < 1048576) return { "value": (bytes / 1024).toFixed(2), "unit": "KB" };
            else if (bytes < 1073741824) return { "value": (bytes / 1048576).toFixed(2), "unit": "MB" };
            else if (bytes < 1099511627776) return { "value": (bytes / 1073741824).toFixed(2), "unit": "GB" };
            else return { "value": (bytes / 1099511627776).toFixed(2), "unit": "TB" };
        },
        ...mapActions("dashboard", ["getStorageReportFromServer"]),
    },
    created(){
        this.getStorageReportFromServer().then((data) => {
            this.storageData = data["bins_storage_info"];
            for(let i = 0; i < this.storageData.length; i++){
                if(this.progressBarColors[i]){
                    this.storageData[i]["color"] = this.progressBarColors[i];
                }else{
                    this.storageData[i]["color"] = Math.floor(Math.random() * this.progressBarColors.length);
                }
            }
        }); 
    }
})
</script>


<style lang="scss" scoped>
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $widgets-bg-color: #202729;
    
    .icon-background-on-hover:hover{
        background: #d1d2d31a;
    }

    .icon-background-on-hover{
        padding: 6px;
        height: 40px;
        width: 45px;
        border-radius: 4px;
        margin: 4px;
    }

    .widget-sub-wrapper{
        display: flex;
        background: $widgets-bg-color;
        padding: 10px;
        height: 89%;
        flex-direction: column;
        color:#cfcfcf;
        overflow: auto;
        .widget-sub-styles{
            background: $widgets-bg-color;
            margin: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            border-radius: 4px;
            .widget-sub-heading{
                font-size: 17px;
                display: flex;
                position: relative;
                inset-inline-start:10px;
                color:$secondary-text-color;
            }
            .widget-sub-value{
                font-size: 50px;
                color:#cfcfcf;
            }
        }
    }

    .progress{
        background: transparent;
        border: $border-color;
        border-radius: 3px;
    }

    .other-info{
        font-size: 12px;
        color: $secondary-text-color;
        display:flex !important;
        span{
            color:#cfcfcf !important;
        }
    }
    
    .dashboard-widget{
        background: $widgets-bg-color;
        box-shadow: 0px 0px 9px 1px #141414;
        border-radius: 4px;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    
    .dropdown-toggle:after{
        display:none !important;
    }

    .modal{
        overflow: hidden !important;
    }

    .dropdown-menu{
        background-color:$secondary-background-color !important;
        border: $border-color;
        position:absolute;
        inset-inline-end:10px !important;
        .dropdown-item{
            color:$text-color;
            font-size:14px !important; 
        }
        .dropdown-item:hover{
            background: $bg-color-on-hover !important;
        }
    }

    .loading{
        color: $dull-text-color;
        position: relative;
        top: 100px;
    }
</style>